import { Grid, Tooltip } from "@mui/material";
import DrawerCM from "components/shared/Drawer";
import EnhancedTable from "components/shared/Table";
import generateHeadCells from "helper/generate-head-cell";
import useHttp from "hooks/use-http";
import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import LoadingCM from "components/shared/Loading";
import PaginationCM from "components/shared/Pagination";
import { deleteAdvByIdRequest, getAdvsRequest } from "api/adv";
import { categoriesData } from "constants/category";
import {
  DEAL_TYPES,
  DOCUMENT_TYPES,
  MAIN_SUB_CATEGORY,
  PLACE_TYPES,
} from "constants/advOptions";
import FilterDataCm from "components/shared/FilterDataCm";
import { StyledIconButton } from "styles/globals";
import { Delete } from "@mui/icons-material";
import DeleteModal from "components/shared/Modal/Delete";
import Toast from "helper/toast";

const headCell = generateHeadCells("advs_list");

const FILTER_INPUTS = [
  {
    id: "search",
    label: "جست و جو",
  },
  {
    id: "category",
    label: "منطقه",
    selectItems: [{ value: "*", title: "همه" }, ...categoriesData],
    type: "select",
  },
  {
    id: "sub_category",
    label: "محله",
    selectItems: [
      { value: "*", title: "همه" },
      ...categoriesData[0].subCategories,
    ],
    type: "select",
    selectFilterCondition: "watch('category') === 1",
  },
  {
    id: "document_type",
    label: "نوع سند",
    selectItems: [{ value: "*", title: "همه" }, ...DOCUMENT_TYPES],
    type: "select",
  },
  {
    id: "place_type",
    label: "نوع ملک",
    selectItems: [{ value: "*", title: "همه" }, ...PLACE_TYPES],
    type: "select",
  },
  {
    id: "deal_type",
    label: "نوع قرارداد",
    selectItems: [{ value: "*", title: "همه" }, ...DEAL_TYPES],
    type: "select",
  },
];

export default function AdvListPage() {
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState({
    id: null,
    open: false,
  });
  const [filterData, setFilterData] = useState(false);

  const [data, setData] = useState({
    count: 0,
    data: [{ content: "آگهی یافت نشد" }],
  });

  const { loading, request } = useHttp();

  const deleteAdvHandler = async () => {
    setModal({
      id: null,
      open: false,
    });
    const res = await request({
      url: deleteAdvByIdRequest,
      values: modal.id,
    });
    if (res) {
      Toast({ type: "delete", title: "آگهی" });
      getData();
    }
  };

  const showModalHandler = (id) => {
    setModal({
      id: id,
      open: true,
    });
  };

  const getData = async (
    hasFilter = false,
    removeFilter = false,
    data = false
  ) => {
    const queryData = data ? data : filterData;
    const query = hasFilter
      ? {
          page: hasFilter ? 1 : page,
          search: queryData?.search,
          category: queryData?.category,
          sub_category: queryData?.sub_category,
          document_type: queryData?.document_type,
          place_type: queryData?.place_type,
          deal_type: queryData?.deal_type,
        }
      : { page: removeFilter ? 1 : page };
    const res = await request({
      url: getAdvsRequest,
      values: query,
    });
    if (res.count) {
      const transformedData = res.data.map((item) => ({
        id: item.id,
        titel: item.title ? item.title.substr(0, 20) : "ثبت نشده",
        main_sub_category: item.main_sub_category
          ? MAIN_SUB_CATEGORY.find(
              (category) => category.value == item.main_sub_category
            ).title
          : "ثبت نشده",
        category:
          item.category &&
          categoriesData.find((category) => category.value === item.category)
            .title,
        sub_category: item.sub_category
          ? categoriesData[0].subCategories.find(
              (category) => category.value === item.sub_category
            ).title
          : "ثبت نشده",
        deal_type: item.deal_type
          ? DEAL_TYPES.find((val) => val.value === item.deal_type).title
          : "ثبت نشده",
        place_type: item.place_type
          ? PLACE_TYPES.find((val) => val.value === item.place_type).title
          : "ثبت نشده",
        document_type: item.document_type
          ? DOCUMENT_TYPES.find((val) => val.value === item.document_type).title
          : "ثبت نشده",
        delete: (
          <StyledIconButton
            variant="countaind"
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              showModalHandler(item.id);
            }}
          >
            <Delete />
          </StyledIconButton>
        ),
      }));

      setData({
        data: transformedData,
        count: res.pages_count,
      });
    } else {
      setData({
        count: 0,
        data: [{ content: "آگهی یافت نشد" }],
      });
    }
  };

  useEffect(() => {
    getData();
  }, [page]);

  return (
    <DrawerCM title="آگهی ها">
      <FilterDataCm
        setFilterData={setFilterData}
        getDataFn={getData}
        inputs={FILTER_INPUTS}
        setPage={setPage}
      />
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={4}>
          <EnhancedTable
            rows={data.data}
            page={page}
            headCells={headCell}
            title="لیست آگهی ها"
            tableBtn={[
              {
                route: "/adv/add",
              },
            ]}
            click={(id) => navigate("/adv/edit/" + id)}
          />
          <PaginationCM
            page={page}
            onChange={(_, page) => setPage(page)}
            pages={data.count}
          />
        </Grid>
      )}
      <DeleteModal
        show={modal.open}
        onClose={() =>
          setModal({
            id: null,
            open: false,
          })
        }
        onDelete={deleteAdvHandler}
      />
    </DrawerCM>
  );
}
